<template>
  <nav class="breadcrumb" aria-label="breadcrumbs">
    <ul>
      <li v-for="(item, index) in breadcrumb" :key="index" :class="{ 'is-active': item.isActive }">
         <router-link  :to="item.path">{{item.title}}</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: ["breadcrumb"]
};
</script>